import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import fleetApi from '../../services/api.service';
import { buildUrlWithParams } from '../../utils/url.utils';
import moment from 'moment';

let timeout = null;
export default function useGetDashboard() {
  const userFactory = useSelector((state) => state.user_factory);
  const prevUserFactoryRef = useRef(userFactory);
  const [dashboardData, setDashboardData] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isFetched, setIsFetched] = useState(false);

  const [filters, setFilters] = useState({
    date: new Date(),
  });

  useEffect(() => {
    if (isFetched || filters?.query?.length) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        getData();
      }, 500);
    }
  }, [filters]);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (prevUserFactoryRef.current !== userFactory) {
      prevUserFactoryRef.current = userFactory;
      getData();
    }
  }, [userFactory]);

  const updateFilter = (key, value) => {
    setFilters((prevFilters) => {
      const newFilters = { ...prevFilters, [key]: value };
      // Reset offset to 0 if any filter other than offset changes
      if (key !== 'offset') {
        newFilters.offset = 0;
      }
      return newFilters;
    });
  };

  const getData = async () => {
    try {
      setIsLoading(true);

      const { date, ...restFilters } = filters;
      const params = {
        ...restFilters,
        ...(date && {
          date: moment(date).format('YYYY-MM-DD'),
        }),
        ...(userFactory && { factory_id: userFactory }),
      };

      const url = buildUrlWithParams('/dashboard', params);

      const response = await fleetApi.get(url);

      if (isFetched) {
        await new Promise((resolve) => setTimeout(resolve, 150));
      }

      if (response.status === 200) {
        setDashboardData(response.data);
      } else {
        throw new Error();
      }
    } catch (error) {
      setError(error?.message || 'Une erreur est survenue.');
    } finally {
      setIsLoading(false);
      setIsFetched(true);
    }
  };

  // J'imagine que ça bougera un jour, peut être dans son propre hook ? Ou alors fait directement dans la page ?
  const downloadResume = async (date) => {
    if (!date) {
      throw new Error('Veuillez sélectionner une date.');
    }

    const dateFormatISO8601 = moment(date).format('YYYY-MM-DD');
    const response = await fleetApi.get(
      `/tours/resume?date=${dateFormatISO8601}`
    );
    if (response.status === 200) {
      return response.data;
    }

    throw new Error(
      'Une erreur est survenue lors du téléchargement du résumé.'
    );
  };

  return {
    dashboardData,
    error,
    isLoading,
    isFirstLoading: isLoading && !isFetched,
    refetch: getData,
    filters,
    updateFilter,
    downloadResume,
  };
}
